import {
    BankingGeneralDisclosure,
    CashBackDisclosure,
} from '@fruitful/compliance';
import { router } from 'expo-router';
import { useSetAtom } from 'jotai';
import { NavigationRow, RowList, ScreenContainer, YStack } from 'smoothie';

import { selectedFAQAtom } from '../../state/SettingsAtoms';
import { faqList } from '../../types/faq';

const FAQListSettingsScreen = () => {
    const setSelectedFAQ = useSetAtom(selectedFAQAtom);

    return (
        <ScreenContainer title="FAQs" hasBackButton={true}>
            <YStack gap={24}>
                {faqList.map(({ category, faqs }) => (
                    <RowList
                        key={category}
                        rowHeaderProps={{ title: category }}
                    >
                        {faqs.map((faq) => (
                            <NavigationRow
                                key={faq.question}
                                title={faq.question}
                                onPress={() => {
                                    setSelectedFAQ(faq);
                                    router.navigate(
                                        '/settings/faq/answered-question',
                                    );
                                }}
                            />
                        ))}
                    </RowList>
                ))}
                <FAQDisclosures />
            </YStack>
        </ScreenContainer>
    );
};

const FAQDisclosures = () => (
    <YStack gap={12} paddingBottom={24}>
        <BankingGeneralDisclosure color="$gray1000" />
        <CashBackDisclosure
            color="$gray1000"
            titleColor="$gray1100"
            superscript="*"
        />
    </YStack>
);

export default FAQListSettingsScreen;
